import React from 'react';
import { Pagination } from 'antd';

const CustomPagination = ({ 
  pagination, 
  onPageChange, 
  loading = false,
  showSizeChanger = true,
  showQuickJumper = false,
  showTotal = true
}) => {
  if (!pagination || pagination.total <= pagination.per_page) {
    return null;
  }

  return (
    <div className="custom-pagination-container">
      <Pagination
        className="custom-pagination"
        current={Number(pagination.current_page)}
        total={Number(pagination.total)}
        pageSize={Number(pagination.per_page)}
        showSizeChanger={showSizeChanger}
        showQuickJumper={showQuickJumper}
        showTotal={showTotal ? (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`
        : false}
        onChange={onPageChange}
        onShowSizeChange={onPageChange}
        disabled={loading}
      />
    </div>
  );
};

export default CustomPagination;
